import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getPricingTableTotals } from '../../state/pricing/selectors';
import GlobalHelper from "../GlobalHelper.jsx";
import PricingTableTotal from "./total.component.jsx";

class PricingTableTotals extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            totalClassName: this.props.totalClassName || '',
            depositType: this.props.depositType || "",
            depositAmount: this.props.depositAmount || '0',
            depositRatio: this.props.depositRatio || 0,
            totals: this.props.totals || [],
            stockDocument: this.props.stockDocument,
            rows: this.props.rows || [],
            payments: this.props.payments || [],
            allowEdit: this.props.allowEdit === true,
            contactId: this.props.contactId || '',
            showLoyalty: this.props.showLoyalty || false,
            quoteId: this.props.quoteId || '',
            invoiceId: this.props.invoiceId || '',
            mainObject: this.props.mainObject || '',
            objectId: this.props.objectId || '',
            hideDeposit: this.props.hideDeposit || false,
            hideMargin: this.props.hideMargin || false,
            onChange: this.props.onChange || function () { },
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            stockDocument: nextProps.stockDocument,
            totalClassName: nextProps.totalClassName || '',
            depositType: nextProps.depositType || "",
            depositAmount: nextProps.depositAmount || '0',
            depositRatio: nextProps.depositRatio || 0,
            rows: nextProps.rows || [],
            totals: nextProps.totals || [],
            payments: nextProps.payments || [],
            allowEdit: nextProps.allowEdit === true,
            showLoyalty: nextProps.showLoyalty || false,
            contactId: nextProps.contactId || '',
            quoteId: nextProps.quoteId || '',
            invoiceId: nextProps.invoiceId || '',
            mainObject: nextProps.mainObject || '',
            objectId: nextProps.objectId || '',
            hideDeposit: nextProps.hideDeposit || false,
            onChange: nextProps.onChange || function () { },
        })
    }


    render() {
        const billingMethods = GlobalHelper.unique(this.state.rows.map(r => r.attributes.billingMethod))
        return (
            this.state.totals.filter(t => billingMethods.includes(t.attributes.billingMethod)).map((t, key) => <PricingTableTotal
                billingMethodsCount={billingMethods.length}
                className={this.state.totalClassName}
                depositAmount={this.state.depositAmount}
                depositType={this.state.depositType}
                depositRatio={this.state.depositRatio}
                key={key}
                total={t}
                allowEdit={this.state.allowEdit}
                showLoyalty={this.state.showLoyalty}
                contactId={this.state.contactId}
                quoteId={this.state.quoteId}
                pricingTableId={this.props.pricingTableId}
                stockDocument={this.props.stockDocument}
                invoiceId={this.state.invoiceId}
                mainObject={this.state.mainObject}
                objectId={this.state.objectId}
                onChange={this.state.onChange}
                hideDeposit={this.state.hideDeposit}
                hideMargin={this.state.hideMargin}
                payments={this.state.payments}
            />)
        )
    }
}

const mapState = (state, props) => {
    const objectId = props.mainObjectId
    let totals = getPricingTableTotals(state, objectId)
    return {
        ...props,
        totals: totals,
    }
}
const mapDispatch = {}

export default connect(mapState, mapDispatch)(injectIntl(PricingTableTotals))


// WEBPACK FOOTER //
// ./src/common/pricing/totals.component.jsx